export enum MissedVisitReasonEnum {
  DrAppt = 1,
  PatientFatigued = 2,
  Weather = 3,
  PatientRefusedTransietIllness = 4,
  PatientRefusedNoReason = 5,
  NotHomeNoAnswer = 6,
  ClinicianIssue = 7,
  Other = 99
}

export const MissedVisitReasonOptions = [
{ id: 1, label: 'Doctor appointment' },
{ id: 2, label: 'Patient too fatigued' },
{ id: 3, label: 'Inclement weather' },
{ id: 4, label: 'Patient refused secondary to transient illness (i.e. cold)' },
{ id: 5, label: 'Patient refused - no reason given' },
{ id: 6, label: 'Patient did not appear to be home for appointment (i.e. no answer)' },
{ id: 7, label: 'Clinician issue (i.e. illness)' },
{ id: 99, label: 'Other' }
];
